import { AbstractPaymentStoreRequest } from '@models/requests/abstract-payment-store-request.model';

export class PaymentBraintreeStoreRequest extends AbstractPaymentStoreRequest {
  public nonce: string;

  public constructor(orderId: string, chargeAmount: number, nonce: string) {
    super(orderId, chargeAmount);
    this.nonce = nonce;
  }
}
